module.exports = __webpack_public_path__ + "static/media/4cardpuresequence.97018b68.png";